module.exports = __webpack_public_path__ + "static/media/SpecializationCourse.bf8e258b.png";